import * as React from 'react';

import moment from 'moment';

import { useIntl } from 'bundles/page/lib/useIntl';
import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';

import _t from 'i18n!nls/xdp';

type Props = {
  totalDuration?: string | null;
};

const KeyInformationCourseDurationItem = ({ totalDuration }: Props) => {
  const intl = useIntl();
  if (!totalDuration) {
    return null;
  }

  let totalHours = moment.duration(totalDuration).asHours();

  totalHours = totalHours > 1 ? Math.floor(totalHours) : 1;

  return (
    <KeyInformationDetailsItem
      title={intl.formatMessage(
        _t('{totalHours, number} {totalHours, plural, =1 { hour} other { hours}} (approximately)'),
        {
          totalHours,
        }
      )}
    />
  );
};

export default KeyInformationCourseDurationItem;
